import React from "react";
interface props {
  className?: string;
}

function Icon1({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 42"
    >
      <circle cx="21" cy="20.996" r="20.5" stroke="#FF752C"></circle>
      <g clipPath="url(#clip0_222_22642)">
        <path
          stroke="#FF752C"
          strokeWidth="0.833"
          d="M17.667 20.162a4.167 4.167 0 100-8.334 4.167 4.167 0 000 8.334zm0 0c1.677 0 3.143.633 4.185 1.685a5.624 5.624 0 011.35 2.228m-5.535-3.913c-3.334 0-5.834 2.5-5.834 5.833v4.166h8.334m.833-3.48l3.492 2.647 5.675-7.5"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_222_22642">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="translate(11 10.996)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon1;
